import React from "react";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import logo from "../../assets/FP_Logo_Black.svg";
import i18n from "../../i18n";
import settings from "../../settings";
import TopSubmenu from "./TopSubmenu";
import Breadcrumbs from "./Breadcrumbs";
import DownArrow from "../../assets/icons/down-arrow.png";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = { menuVisible: false, subMenuVisible: null };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.submenuRef = React.createRef();
  }

  canHover() {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleScroll() {
    if (this.state.subMenuVisible !== null) {
      this.setState({ subMenuVisible: null });
    }
  }

  handleOutsideClick(e) {
    // If submenu is open and click happened outside submenu container
    if (
      this.state.subMenuVisible !== null &&
      this.submenuRef.current &&
      !this.submenuRef.current.contains(e.target)
    ) {
      this.setState({ subMenuVisible: null });
    }
  }

  onHamburgerClick() {
    this.setState({ menuVisible: !this.state.menuVisible });
  }

  onMenuClick(menu, event) {
    this.setState({ menuVisible: false });
    if (menu.url === "contact") {
      this.props.setContactVisible(true);
    }
    if (menu.url?.startsWith("search")) {
      window.location.reload();
    }
    if (menu.onClickFunction) {
      menu.onClickFunction();
      event.preventDefault();
    }
  }

  isCurrentPath(url) {
    return url.startsWith(window.location.pathname);
  }

  render() {
    const allowMouseHover = this.canHover();
    return (
      <div className="topbar-container">
        <div className="topbar">
          <div className="fp-logo-col">
            <a href="/">
              <img className="fp-logo" src={logo} alt="Frank Porter" />
            </a>
          </div>
          <div
            className={"hamburger" + (this.state.menuVisible ? " opened" : "")}
            onClick={this.onHamburgerClick.bind(this)}
          >
            <div></div>
          </div>
          <div className="fp-menu-col" ref={this.submenuRef}>
            <TopSubmenu {...this.props} reversed={true} mainColor={true} />
            <ul
              className={"fp-menu" + (this.state.menuVisible ? " visible" : "")}
            >
              {settings.menuItems2
                .filter(
                  (menu) =>
                    menu.visibleTopMenu &&
                    !menu.hiddenInLanguages.includes(i18n.language)
                )
                .map((menu, index) => {
                  return ["aboutUs"].includes(menu.translationKey) ? (
                    <li key={index} onClick={this.onMenuClick.bind(this, menu)}>
                      <div className="menu-item-container">
                        <a
                          href={menu.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          {this.props.t(menu.translationKey)}
                        </a>
                      </div>
                    </li>
                  ) : (
                    <li key={menu.translationKey}>
                      {menu.onClickFunction ? (
                        this.props.t(menu.translationKey)
                      ) : (
                        <div
                          className={
                            "menu-item-container" +
                            (this.state.subMenuVisible === index &&
                            ["dubai", "abu-dhabi"].includes(menu.translationKey)
                              ? " hover"
                              : "")
                          }
                          onMouseEnter={
                            allowMouseHover
                              ? () => this.setState({ subMenuVisible: index })
                              : undefined
                          }
                          onMouseLeave={
                            allowMouseHover
                              ? () => this.setState({ subMenuVisible: null })
                              : undefined
                          }
                        >
                          <Link
                            onClick={this.onMenuClick.bind(this, menu)}
                            to={`/${menu.url}`}
                            className={
                              this.isCurrentPath(`/${menu.url}`)
                                ? "highlighted"
                                : ""
                            }
                          >
                            {this.props.t(menu.translationKey)}
                          </Link>
                          {["dubai", "abu-dhabi"].includes(
                            menu.translationKey
                          ) && (
                            <img
                              alt="down-arrow"
                              src={DownArrow}
                              className="down-arrow"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                this.setState((prevState) => ({
                                  subMenuVisible:
                                    prevState.subMenuVisible !== index ? index : null,
                                }));
                              }}
                            />
                          )}
                          {this.state.subMenuVisible === index &&
                            ["dubai", "abu-dhabi"].includes(
                              menu.translationKey
                            ) && (
                              <div className="menu-item-submenu">
                                <ul>
                                  {[
                                    ...(menu.translationKey === "dubai"
                                      ? settings.tagsDubai
                                      : settings.tagsAbuDhabi),
                                  ].map((item, ind) => (
                                    <li key={ind}>
                                      <Link
                                        className={
                                          this.isCurrentPath(
                                            `/${menu.url}/${item.slug}`
                                          )
                                            ? "highlighted"
                                            : ""
                                        }
                                        onClick={(event) => {
                                          event.stopPropagation();
                                          this.setState({
                                            subMenuVisible: null,
                                            menuVisible: false,
                                          });
                                          this.onMenuClick(item, event);
                                        }}
                                        to={`/${menu.url}/${item.slug}`}
                                      >
                                        {this.props.t(item.translationKey)}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                        </div>
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
        {this.props.location.pathname !== "/" && (
          <Breadcrumbs t={this.props.t} paramObj={this.props.paramObj} />
        )}
      </div>
    );
  }
}

export default withRouter(withTranslation("common")(Header));
